import { FC } from "react";
import { Line } from "react-chartjs-2";
import styled from "styled-components";

import useDropGraph from "@/hooks/useDropGraph";
import { OptimisationRetentionResource } from "@/types/resources";

const Graph = styled.div`
  width: 122px;
  overflow-y: hidden;
`;

interface Props {
  data: OptimisationRetentionResource[];
}

const RetentionGraph: FC<Props> = ({ data }) => {
  const filteredRetentions = data
    .filter((dataPoint) => dataPoint.marked)
    .reduce<number[]>(
      (previousValue, currentValue) => [
        ...previousValue,
        currentValue.audience_watch_ratio,
      ],
      []
    );

  const filteredRetentionIndexes = data.reduce<number[]>(
    (previousValue, currentValue, index) =>
      currentValue.marked ? [...previousValue, index] : previousValue,
    []
  );

  const { graphData, graphOptions } = useDropGraph(
    data.map((dataPoint) => dataPoint.elapsed_video_time_ratio),
    data.map((dataPoint) => dataPoint.audience_watch_ratio),
    filteredRetentions,
    filteredRetentionIndexes
  );
  return (
    <Graph>
      <Line data={graphData} options={graphOptions} />
    </Graph>
  );
};

export default RetentionGraph;
